import {
  getAllTag,
  GetFirstLevelClassification,
  GetSecondLevelClassification,
} from "@/api/article";

const emptyState = {
  ing: false,
  articleId: null,
  articleType: null,
  url: "",
  firstLevelClassId: "",
  secondLevelClassId: "",
  firstLevelClass: [],
  allSecondLevelClass: [],
  secondLevelClass: [],
  tags: [],
  articleTitle: "",
  content: "",
  html: "",
  source: "",
  createTime: "",
  collectionTime: "",
  collectionProcess: 0,
  fileList: [],
};

const article = {
  state: {
    ...emptyState,
  },
  mutations: {
    SET_DATA: (state, data) => {
      state.url = data.url;
      state.firstLevelClassId = data.firstLevelClassId;
      state.secondLevelClassId = data.secondLevelClassId;
      state.tags = data.tags;
      // state.add_tags = data.add_tags
      state.articleId = data.articleId;
      state.articleTitle = data.articleTitle;
      state.articleType = data.articleType;
      state.content = data.content;
      state.html = data.html;
      state.source = data.source;
      state.createTime = data.createTime;
      state.collectionTime = data.collectionTime;
      state.collectionProcess = data.collectionProcess;
      state.fileList = data.fileList;
    },
    SET_Id: (state, articleId) => {
      state.articleId = articleId;
    },
    SET_STATUS: (state, status) => {
      state.ing = status;
    },
    ADD_TAG: (state, tag) => {
      state.tags.push(tag);
    },
    SET_TAGS: (state, tags) => {
      state.tags = tags;
    },
    TOGGLE_TAG: (state, idx) => {
      state.tags[idx].isselected_up = !state.tags[idx].isselected_up;
    },
    SET_FIRST_LEVEL_CLASS: (state, firstLevelClass) => {
      state.firstLevelClass = firstLevelClass;
    },
    SET_ALL_SECOND_LEVEL_CLASS: (state, secondLevelClass) => {
      state.allSecondLevelClass = secondLevelClass;
    },
    CHANGE_ARTICLE_FIRST_CLASS: (state, firstLevelClassId) => {
      state.firstLevelClassId = firstLevelClassId;
      state.secondLevelClassId = NaN;
    },
    CHANGE_ARTICLE_SECOND_CLASS: (state, secondLevelClassId) => {
      state.secondLevelClassId = secondLevelClassId;
    },
    CLEAR_ARTICLE_DATA: (state) => {
      Object.assign(state, emptyState);
    },
  },

  getters: {
    getArticleInfo: (state) => {
      return {
        ing: state.ing,
        url: state.url,
        firstLevelClassId: state.firstLevelClassId,
        secondLevelClassId: state.secondLevelClassId,
        tags: state.tags,
        // add_tags: state.add_tags,
        articleId: state.articleId,
        articleTitle: state.articleTitle,
        articleType: state.articleType,
        content: state.content,
        html: state.html,
        source: state.source,
        createTime: state.createTime,
        collectionTime: state.collectionTime,
        collectionProcess: state.collectionProcess,
        fileList: state.fileList,
      };
    },
    getArticleId: (state) => {
      return {
        articleId: state.articleId,
      };
    },
  },

  actions: {
    recordData({ commit }, data) {
      commit("SET_STATUS", true);
      commit("SET_DATA", data);
    },
    recordId({ commit }, articleId) {
      commit("SET_Id", articleId);
    },
    clearData({ commit }) {
      commit("SET_STATUS", false);
      commit("SET_DATA", {
        ing: false,
        articleId: null,
        articleType: null,
        url: "",
        firstLevelClassId: "",
        secondLevelClassId: "",
        tags: [],
        // add_tags: [],
        articleTitle: "",
        content: "",
        html: "",
        source: "",
        createTime: "",
        collectionTime: "",
        collectionProcess: 0,
        fileList: [],
      });
    },

    getClassifications({ commit }) {
      Promise.all([
        GetFirstLevelClassification(),
        GetSecondLevelClassification(),
      ]).then((res) => {
        commit("SET_FIRST_LEVEL_CLASS", res[0].data);
        commit("SET_ALL_SECOND_LEVEL_CLASS", res[1].data);
      });
    },

    getTagsAndActiveSome({ commit }, labelIds) {
      getAllTag().then((res) => {
        const tags = res.data.map((item) => {
          console.log(labelIds);
          item.isselected_up = labelIds.includes(item.labelId);
          return item;
        });
        commit("SET_TAGS", tags);
      });
    },
  },
};

export default article;
